module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/related/id/4-bf73d93fd93e3609e8160fb00fa29893.jpg";